import { Controller } from "@hotwired/stimulus"

// Opens a modal <dialog> when its Turbo Frame loads server-rendered content (for example a
// confirmation form), and empties the frame on close so the next activation fetches it fresh.
// Connects to data-controller="frame-dialog"
export default class extends Controller {
  static targets = ["dialog", "frame"]

  open() {
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  reset() {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.replaceChildren()
  }

  // Close before Turbo renders the redirected page so the morph never meets an open modal.
  submitEnd(event) {
    if (event.detail.success) this.close()
  }

  // Links given role="switch" should also respond to the Space key.
  press(event) {
    event.preventDefault()
    event.currentTarget.click()
  }
}
